import {
    Button,
  Layout,
    Space,
  notification,
  Typography,
} from 'antd';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import DataTable, { DataTableColumnProps } from '../../shared/DataTable/DataTable';
import DataTableButtonUtil from '../../shared/DataTable/DataTableButtonUtil';
import GbReportsDTO from '../../../models/GbReportsDTO';
import DataTableColumnUtil from '../../shared/DataTable/DataTableColumnUtil';
import PublicReportsApiService from '../../../api/PublicReportsApiService';
import HistoryUtil from '../../../utils/HistoryUtil';
import Routes from '../../../consts/Routes';
import { ArrowLeftOutlined } from '@ant-design/icons';
import DataTableCellRendererUtil from '../../shared/DataTable/DataTableCellRendererUtil';
import TableRequestDTO from '../../../models/TableRequestDTO';
import TableExportDTO from '../../../models/TableExportDTO';
import TableResponseDTO from '../../../models/TableResponseDTO';

const { Content } = Layout;

interface GbReportsProps {

}

interface GbReportsState {
    tableColumns: DataTableColumnProps<GbReportsDTO>[];
    exporting: boolean;
    loading: boolean;
}

class GbReports extends React.Component<RouteComponentProps<GbReportsProps>, GbReportsState> {

  constructor(props: RouteComponentProps<GbReportsProps>) {
    super(props);

    this.state = {
      tableColumns: this.getTableColumns(),
      exporting: false,
      loading: false,
    };
  }

    render() {
      const { exporting, tableColumns, loading} = this.state;
      const actionButtons = [];
      actionButtons.push(DataTableButtonUtil.Reset());
      actionButtons.push(DataTableButtonUtil.Export((tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          const exportDTO: TableExportDTO = TableExportDTO.create(
              {
                  TableRequest: tableRequest
              });
          return PublicReportsApiService.exportGiftBequestReportList(exportDTO)
              .finally(() => {
                  this.setState({ exporting: false });
              });
      }, exporting));
    return (
        <Content className="content-pad">
            <DataTable
                globalSearch={true}
                serverSide={true}
                buttonBar={actionButtons}
                columns={tableColumns}
                tableProps={{
                    rowKey: 'id',
                    locale: { emptyText: 'No Reports Currently Match Your Filter' },
                    loading: loading,
                }}
                fetchData={this.fetchGBReports}
                styleOptions={{ compact: true, alternatingRowHighlight: true }}
                title={
                <Button type="link" onClick={() => HistoryUtil.push(Routes.generate(Routes.PUBLIC_REPORTS))}>
                    <Typography.Title level={4}>
                    <Space size="large">
                        <ArrowLeftOutlined className="public-report-links"/> Gifts/Bequests
                    </Space>
                    </Typography.Title>
                </Button>
                }
            />
      </Content>
    );
  }

  private getTableColumns = (): DataTableColumnProps<GbReportsDTO>[] => {
    const generatedOn = DataTableColumnUtil.Date<GbReportsDTO>('Received Date', 'recievedOn');
    generatedOn.render = DataTableCellRendererUtil.ShortDate;
      return [
        DataTableColumnUtil.Text('Year', 'year', null),
        DataTableColumnUtil.Text('Department', 'department', null),
        DataTableColumnUtil.Text('Division', 'division'),
        DataTableColumnUtil.Text('Donor', 'donorName'),
        generatedOn,
        DataTableColumnUtil.Text('Filing Status', 'filingStatus'),
        DataTableColumnUtil.Buttons('fileName',
        [
          { text: 'View', onClick: (rowData) => window.open(rowData.fileUrl || '') },
        ])
      ];
    }

    private fetchGBReports = (
        requestState: TableRequestDTO,
        checkEcho: () => boolean,
        callback: (response: TableResponseDTO<GbReportsDTO>) => void
    ) => {
        this.setState({ loading: true });
        return PublicReportsApiService.getGbReports(requestState)
            .then((res) => {
                if (!checkEcho()) {
                    return;
                }
                callback(res);
                this.setState({ loading: false });
            })
            .catch((error: any) => {
                this.setState({ loading: false });
                notification.error({
                    message: error.message,
                    description: error.description,
                });
            });
    };
}

export default GbReports;